export function time_override(sh,sm,eh,em,sha,sma,eha,ema) {
    if ((eha*60 + ema <= sh*60 + sm)) return false;
    if ((sha*60 + sma >= eh*60 + em)) return false;
    return true;
}